"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _core = require("@emotion/core");
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Loader = function Loader() {
  var animation = (0, _core.keyframes)({
    "0%": {
      boxShadow: "0 1em 0 -1.3em"
    },
    "80%": {
      boxShadow: "0 1em 0 -1.3em"
    },
    "100%": {
      boxShadow: "0 1em 0 -1.3em"
    },
    "40%": {
      boxShadow: "0 1em 0 0"
    }
  });
  var sharedStyles = {
    content: '""',
    borderRadius: "50%",
    height: "1em",
    width: "1em",
    animationFillMode: "both",
    animation: "".concat(animation, " 1.4s infinite ease-in-out")
  };
  var additionalStyles = {
    position: "absolute",
    top: 0
  };
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      padding: ["35vh 0 44vh", null, null, "38vh 0 52vh", null]
    }
  }, __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, sharedStyles), {}, {
      margin: "auto",
      color: "neutral900",
      fontSize: "10px",
      transform: "translateZ(0)",
      animationDelay: "0",
      "::after": _objectSpread(_objectSpread(_objectSpread({}, sharedStyles), additionalStyles), {}, {
        left: "2.5em",
        animationDelay: "0.16s"
      }),
      "::before": _objectSpread(_objectSpread(_objectSpread({}, sharedStyles), additionalStyles), {}, {
        left: "-2.5em",
        animationDelay: "-0.16s"
      })
    })
  }));
};
var _default = Loader;
exports["default"] = _default;